import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { customColorSets } from "../../../utils/custom-color-sets";
import { BarLineComboOptions } from "../../../utils/models/bar-line-combo-options";


@Component({
    selector : 'neu-charts-combo-bar-line',
    template: `
<div class="chart-container" *ngIf="(dataBar && (dataBar.length > 0)) && (dataLine && (dataLine.length > 0))">
    <neu-charts-combo-bar-line-raw
        [scheme]="colorScheme"
        [colorSchemeLine]="lineChartScheme"
        [results]="dataBar"
        [lineChart]="dataLine"
        [legend]="options.showLegend"
        [xAxis]="options.showXAxis"
        [yAxis]="options.showYAxis"
        [showXAxisLabel]="options.showXAxisLabel"
        [showYAxisLabel]="options.showYAxisLabel"
        [xAxisLabel]="options.xAxisLabel"
        [yAxisLabel]="options.yAxisLabel"
        
        [showRightYAxisLabel]="options.showRightYAxisLabel"
        [yAxisLabelRight]="options.yAxisLabelRight"

        [yLeftAxisScaleFactor]="yLeftAxisScale"
        [yRightAxisScaleFactor]="yRightAxisScale"
        [yAxisTickFormatting]="yLeftTickFormat"
        [yRightAxisTickFormatting]="yRightTickFormat"
        (select)="mSelectedEvent($event)">
        </neu-charts-combo-bar-line-raw>
</div>
<no-data *ngIf="(!dataBar) || (dataBar.length <= 0) || (!dataLine) || (dataLine.length <= 0)"></no-data>`
})
export class BarLineWrapperComponent implements OnInit {

    @Input('dataBar') dataBar: any[] = [];
    @Input('dataLine') dataLine: any[] = [];
    @Input('options') customOptions: BarLineComboOptions;

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    options: BarLineComboOptions = new BarLineComboOptions();

    colorScheme = customColorSets.find(s => s.name == 'palatte');

    constructor() { }

    ngOnInit() {
        console.log(this.dataBar, this.dataLine);
        Object.assign(this.options, this.customOptions);
    }

    mSelectedEvent(event: any) {
        this.onSelect.emit(event);
    }

    yLeftAxisScale(min, max) {
        return { min: `${min}`, max: `${max}` };
    }

    yRightAxisScale(min, max) {
        return { min: `${min}`, max: `${max}` };
    }

    yLeftTickFormat(data) {
        return `${data.toLocaleString()}`;
    }

    yRightTickFormat(data) {
        return `${data}%`;
    }
}